import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

@Component({
	selector: 'app-modale-rifiuta',
	standalone: true,
	imports: [CommonModule, FormsModule],
	template: `
    <div class="modal-card">
      <div class="modal-icon modal-icon-error">
        <i class="bi bi-x-circle"></i>
      </div>
      <div class="modal-title">Rifiuta Pratica</div>
      <div class="modal-subtitle">Indica il motivo del rifiuto per procedere.</div>
      
      <textarea 
        class="form-control modal-textarea mb-4" 
        [(ngModel)]="motivo" 
        placeholder="Motivo del rifiuto..."
        rows="3"></textarea>
      
      <div class="d-flex gap-2">
        <button class="btn btn-outline-secondary w-100" (click)="activeModal.dismiss()">Annulla</button>
        <button class="btn btn-danger w-100" ngbAutofocus (click)="activeModal.close(motivo())">Rifiuta</button>
      </div>
    </div>
  `,
})
export class ModaleRifiutaComponent {
	activeModal = inject(NgbActiveModal);
	motivo = signal('');
}
